import { LANGUAGE_CODE } from "consts";

export const LOCALE_DICT: Record<LANGUAGE_CODE, string> = {
  de: "de",
  ch: "de",
  at: "de",
  en: "en-gb", // picked as the en-us date format would be super confusing to alsost everyone at Klim
  zu: "en-gb", // moment doesn't have a zu locale, and it's being used as english anyway
  [LANGUAGE_CODE.ACHOLI]: "en-gb", // this language is only used for in-context-localization for crowdin
  pl: "pl",
  "cs-CZ": "cs",
  "sk-SK": "sk",
  "en-GB": "en-gb",
  "en-US": "en-us",
  "hu-HU": "hu",
};
